module.exports = __webpack_public_path__ + "static/media/figura-estrella.30f046ab.svg";